import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const SmartSearchRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hasChatMode = params.get('mode') === 'chat';

  if (location.pathname !== '/chat-with-mimi' || hasChatMode) {
    if (hasChatMode) params.delete('mode');
    const search = params.toString();
    // `mode=chat` stays out of the visible URL but keeps its entry meaning via
    // router state, which SmartSearchLanding reads like the old query mode.
    const state = hasChatMode
      ? { ...((location.state as Record<string, unknown> | null) || {}), smartSearchUrlEntryMode: 'chat' }
      : location.state;
    const redirect = <Navigate replace to={{ pathname: '/chat-with-mimi', search: search ? `?${search}` : '', hash: location.hash }} state={state} />;
    // Already on /chat-with-mimi: keep the page mounted while the URL is cleaned,
    // so an in-page `?mode=chat` navigation does not remount the landing.
    if (location.pathname === '/chat-with-mimi') return <>{children}{redirect}</>;
    return redirect;
  }

  return <>{children}</>;
};

export default SmartSearchRoute;
